<template>
  <div id="pogoda-klimat">
    <T1HeadScripts rodzajstrony="pogoda" />
    <a-layout id="components-layout-demo-top" class="layout">
      <T1Header />
      <div class="container" id="t1content">
        <a-layout-content>
          <T1PogodaKlimatContent />
        </a-layout-content>
      </div>
      <T1Footer />
    </a-layout>
  </div>
</template>

<script>
import T1HeadScripts from "./components/T1HeadScripts";
import T1Header from "./components/T1Header/T1Header";
import T1PogodaKlimatContent from "./components/T1PogodaKlimatContent";
import T1Footer from "./components/T1Footer/T1Footer";

export default {
  name: "pogoda-klimat",
  data: () => ({}),
  methods: {},
  mounted() {},
  components: {
    T1HeadScripts,
    T1Header,
    T1PogodaKlimatContent,
    T1Footer
  }
};
</script>
